import React from "react";

import {
  selectAuth,
  signIn as _signIn,
  signOut as _signOut,
  $disfigureSession as _$disfigureSession,
} from "@/store/features/authSlice";
import { useAppSelector, useAppDispatch } from "@/store/hooks";

export const useAuth = () => {
  const { session, status, error } = useAppSelector(selectAuth);

  const dispatch = useAppDispatch();

  const signIn = React.useCallback(async () => {
    await dispatch(_signIn());
  }, []);
  const signOut = React.useCallback(async () => {
    await dispatch(_signOut());
  }, []);
  const $disfigureSession = React.useCallback(async () => {
    dispatch(_$disfigureSession());
  }, []);

  return {
    user: session?.user,
    session,
    status,
    error,
    isAuthenticated: status === "authenticated",
    isLoading: status === "loading",
    accessToken: session?.access_token,
    idToken: session?.id_token,
    tokenType: session?.token_type,
    expiresAt: session?.expires_at,
    signIn,
    signOut,
    $disfigureSession,
  };
};
